import { Component, OnInit } from '@angular/core';
import { RoutesApp } from "@enums";
import { Router } from "@angular/router";
declare var utils: any;
@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor(private _router: Router) { }

  ngOnInit(): void {
    utils.tooltip();
  }

  returnHome() {
    this._router.navigate([ `/${ RoutesApp.Dashboard }` ])
  }

}
